module.exports = __webpack_public_path__ + "img/qiye.cbb1c258.png";